// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isInstanceof(obj: unknown, type: any): boolean {
  return obj instanceof type;
}
